var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGmail = function SvgGmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 22.5 20.25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16.806 20.25H5.692A5.693 5.693 0 0 1 0 14.569V5.681A5.693 5.693 0 0 1 5.692 0h11.114a5.728 5.728 0 0 1 4.028 1.667A5.638 5.638 0 0 1 22.5 5.681v8.888a5.694 5.694 0 0 1-5.694 5.681M4.539 5.9a.825.825 0 0 0-.6.253.859.859 0 0 0-.08 1.125l.148.146 5.118 3.994a3.52 3.52 0 0 0 2.194.764 3.577 3.577 0 0 0 2.2-.764l5.081-4.06.09-.09a.871.871 0 0 0-.013-1.125.935.935 0 0 0-.594-.293h-.047a.855.855 0 0 0-.584.226l-5.073 4.05a1.761 1.761 0 0 1-1.121.406 1.791 1.791 0 0 1-1.129-.406L5.063 6.075a.875.875 0 0 0-.524-.175",
    "data-name": "Message"
  })));
};
export default SvgGmail;